import StreamlineProcurementProcesses from "../../../../src/pages/use-cases/page-content/financial/streamline-procurement-processes.md";
import * as React from 'react';
export default {
  StreamlineProcurementProcesses,
  React
};